import { Widget } from '@typeform/embed-react'
import { ErrorReloadSmall } from 'modules/common/components/ErrorReloadSmall/ErrorReloadSmall'
import { Spinner } from 'modules/common/components/_ui/Spinner/Spinner'

interface Props {
  isError?: boolean
  isLoading?: boolean
  hiddenFields?: Record<string, string>
  formId: string
  onTypeformSubmitted: () => Promise<unknown> | unknown
  errorRefetch: () => void
}

export const TypeformModalContent = ({
  isLoading,
  errorRefetch,
  formId,
  hiddenFields,
  onTypeformSubmitted,
  isError,
}: Props) => {
  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Spinner className="text-primary" />
      </div>
    )
  }

  if (isError) {
    return <ErrorReloadSmall onReload={errorRefetch} />
  }

  return (
    <Widget
      id={formId}
      hidden={hiddenFields}
      onSubmit={onTypeformSubmitted}
      className="h-full w-full"
    />
  )
}
